export default __webpack_public_path__ + "static/international-yards-mobile-59dbc5e9d347f9cfcadd1a2b7ad91620.svg";